import { render, staticRenderFns } from "./Price1Template.vue?vue&type=template&id=3c5ce233"
import script from "./Price1Template.vue?vue&type=script&lang=js"
export * from "./Price1Template.vue?vue&type=script&lang=js"
import style0 from "./Price1Template.vue?vue&type=style&index=0&id=3c5ce233&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports